// رسیدگی نهایی صورت وضعیت‌ها
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePager, CountBadge } from '../../components/paging';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import ControlRequestDetail from './ControlRequestDetail';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFa   = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
const fmtNum = n => (n ? Number(n).toLocaleString('fa-IR') : '•');

// نوع صورت وضعیت (0..18)
const REQUEST_TYPE = ['عادی', 'تعدیل', 'بیمه تمام خطر', 'تفاوت نرخ ارز', 'تاخیر در پرداخت', 'تفاوت بهای مصالح',
  'پیش پرداخت', 'تعلیق', 'جبران آثار کرونا', 'نظارت عالیه', 'وجه التزام', 'تاخیر در تحویل زمین',
  'اسناد سپرده آزاد شده پیش از سررسید', 'مالیات بر ارزش افزوده', 'کسر بهای مصالح',
  'تفاوت سود مالیات بر ارزش افزوده', 'حق الزحمه نگهبانی', 'سایر هزینه ها', 'تفاوت بروزرسانی قرارداد'];
const CREDIT_PLACE = ['دستگاه اجرایی', 'خیرین'];

const EMPTY = {
  contract_id: 0, contract_disp: '', contractor: '', contract_type: '', contract_cost: 0, contract_begin: '',
  contract_no: '', contract_date: '',
  serial_no: '', request_type: 0, request_no: '', credit_place_type: 0, request_amount_to_now: '',
  from_date: '', to_date: '', is_final: false,
  supervisor_id: 0, supervisor: '', buildings_visor_id: 0, buildings_visor: '',
  installations_visor_id: 0, installations_visor: '', handler_id: 0, handler: '',
  confirmed_amount: '', supervision_amount: '', supervision_no: '', supervision_date: '',
  contractor_letter_no: '', contractor_letter_date: '', secretariat_no: '', secretariat_date: '',
  received_date: '', send_to_visor_date: '', receive_from_visor_date: '',
  send_letter_no: '', send_letter_date: '', date40: '', send_to_contractor_request: false, remark: '',
};

const API = (path, opts = {}) => fetch(`/api/contract${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

function Lookup({ label, value, endpoint, onPick, flex = 1 }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const search = async (text) => { setQ(text); const j = await API(`${endpoint}?q=${encodeURIComponent(text)}`); if (j.ok) { setRows(j.rows); setOpen(true); } };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex, position: 'relative' }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value || q} onFocus={() => search(q)} onChange={e => search(e.target.value)} placeholder="جستجو..." style={ui.input} />
      {value && <button onClick={() => { onPick({ id: 0, display: '' }); setQ(''); }}
        style={{ position: 'absolute', left: '6px', top: '30px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#c62828', fontSize: '14px' }}>✕</button>}
      {open && rows.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', right: 0, left: 0, background: '#fff', border: '1px solid #e0e0e0',
          borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 900, maxHeight: '220px', overflowY: 'auto', marginTop: '2px' }}>
          {rows.map(r => (
            <div key={r.id} onClick={() => { onPick(r); setOpen(false); setQ(''); }}
              style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '1px solid #f0f0f0' }}
              onMouseEnter={e => e.currentTarget.style.background = '#e8f0fe'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>{r.display}</div>
          ))}
        </div>
      )}
    </div>
  );
}

function TInput({ label, val, onCh, flex = 1, type = 'text', disabled }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex }}>
      <label style={ui.mlabel}>{label}</label>
      <input type={type} value={val} onChange={e => onCh(e.target.value)} disabled={disabled}
        style={{ ...ui.input, background: disabled ? '#f2f2f2' : '#fff' }} />
    </div>
  );
}

function DateField({ label, val, onCh, flex = 1 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex }}>
      <label style={ui.mlabel}>{label}</label>
      <JalaliDatePicker value={val} onChange={onCh} placeholder={label} />
    </div>
  );
}

export default function ControlContractorRequestList({ user, onBack }) {
  // دکمه‌های فرم FRMCONTROLCONTRACTORREQUEST؛ دیدن = دسترسی
  const vbf = useFormButtons('FRMCONTROLCONTRACTORREQUEST', ["BTNNEW","BTNEDIT","BTNDELETE","BTNSENDTOVISOR","BTNOK"]);
  const [data, setData]         = useState([]);
  const pager = usePager();          // صفحه‌بندی مشترک — ۲۰۰ ردیف در هر صفحه
  const [search, setSearch]     = useState('');
  const [selected, setSelected] = useState(null);
  const [loading, setLoading]   = useState(false);
  const [modal, setModal]       = useState(null);
  const [form, setForm]         = useState(EMPTY);
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [toast, setToast]       = useState('');
  const [tab, setTab]           = useState('contract');
  const [detail, setDetail]     = useState(null);

  const showToast = m => { setToast(m); setTimeout(() => setToast(''), 3000); };

  const cols = [
    { h: 'سریال', k: 'serial_no', w: 70, fa: true },
    { h: 'قرارداد', k: 'contract_disp', w: 150, right: true },
    { h: 'پیمانکار', k: 'contractor', w: 180, right: true },
    { h: 'نوع صورت وضعیت', k: 'request_type_name', w: 130, right: true },
    { h: 'شماره', k: 'request_no', w: 70, fa: true },
    { h: 'وضعیت', k: 'is_final', w: 70, final: true },
    { h: 'مبلغ درخواستی پیمانکار', k: 'request_amount_to_now', w: 150, num: true, color: '#1a237e' },
    { h: 'مبلغ تایید شده', k: 'confirmed_amount', w: 140, num: true, color: '#1b5e20' },
    { h: 'مبلغ تایید شده قبلی', k: 'prev_confirmed', w: 140, num: true, color: '#6a1b9a' },
    { h: 'سرناظر', k: 'supervisor', w: 130, right: true },
    { h: 'رسیدگی کننده', k: 'handler', w: 130, right: true },
    { h: 'تاریخ ورود به رسیدگی', k: 'received_date', w: 120, mono: true },
    { h: 'شماره نامه خروج', k: 'send_letter_no', w: 100, fa: true },
    { h: 'ارسال به حواله', k: 'send_to_contractor_request', w: 90, yn: true },
  ];
  const [colW, setColW] = useState(cols.map(c => c.w));
  const colWRef = useRef(colW);
  useEffect(() => { colWRef.current = colW; }, [colW]);
  const startResize = useCallback((idx, e) => {
    e.preventDefault(); e.stopPropagation();
    const sx = e.clientX, sw = colWRef.current[idx];
    const onMove = ev => setColW(w => { const n = [...w]; n[idx] = Math.max(40, sw + (sx - ev.clientX)); return n; });
    const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
    document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
  }, []);

  const load = useCallback(async (pg = 1, sr = search) => {
    setLoading(true); setError(''); if (pg === 1) setSelected(null);
    const j = await API(`/controls/?page=${pg}&search=${encodeURIComponent(sr)}`);
    setLoading(false);
    if (j.ok) { setData(prev => pager.merge(prev, j, pg)); }
    else setError(j.msg);
  }, [search]);

  useEffect(() => { load(1, ''); }, []);   // eslint-disable-line

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));

  // پس از انتخاب قرارداد: بارگذاری مشخصات
  const pickContract = async (r) => {
    if (!r.id) { setForm(f => ({ ...f, contract_id: 0, contract_disp: '', contractor: '', contract_type: '', contract_cost: 0, contract_begin: '', contract_no: '', contract_date: '' })); return; }
    const j = await API(`/controls/spec/${r.id}/`);
    if (j.ok) {
      const s = j.spec;
      setForm(f => ({ ...f, contract_id: r.id, contract_disp: s.contract_disp, contractor: s.contractor,
        contract_type: s.contract_type, contract_cost: s.contract_cost, contract_begin: s.contract_begin,
        contract_no: s.contract_no, contract_date: s.contract_date }));
      // شماره صورت وضعیت پیشنهادی
      if (modal === 'new') {
        const nj = await API(`/controls/next-request-no/?contract_id=${r.id}&request_type=${form.request_type}`);
        if (nj.ok) setForm(f => ({ ...f, request_no: nj.request_no }));
      }
    }
  };

  const changeType = async (v) => {
    setForm(f => ({ ...f, request_type: v }));
    if (modal === 'new' && form.contract_id) {
      const nj = await API(`/controls/next-request-no/?contract_id=${form.contract_id}&request_type=${v}`);
      if (nj.ok) setForm(f => ({ ...f, request_no: nj.request_no }));
    }
  };

  const openNew  = () => { if (!vbf.can('BTNNEW')) return; setForm(EMPTY); setError(''); setTab('contract'); setModal('new'); };
  const openEdit = () => { if (!vbf.can('BTNEDIT')) return;
    if (!selected) return;
    if (selected.havaleh_issued) { showToast('برای این رکورد حواله صادر شده و قابل ویرایش نیست'); return; }
    setForm({ ...EMPTY, ...selected }); setError(''); setTab('contract'); setModal('edit');
  };
  const openDel  = () => { if (!vbf.can('BTNDELETE')) return; if (selected) setModal('delete'); };

  const save = async () => {
    setSaving(true); setError('');
    const j = modal === 'new'
      ? await API('/controls/create/', { method: 'POST', body: JSON.stringify(form) })
      : await API(`/controls/${selected.id}/update/`, { method: 'PUT', body: JSON.stringify(form) });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast(j.msg); load(1); }
    else setError(j.msg);
  };

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/controls/${selected.id}/delete/`, { method: 'DELETE' });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('حذف شد'); load(1); }
    else { setError(j.msg); setModal(null); }
  };

  const toolbar = (
    <>
      <div style={ui.toolBtns}>
        {vbf.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✎ ویرایش</button>}
        {vbf.can('BTNDELETE') && <button onClick={openDel} disabled={!selected} style={{ ...ui.btnDel, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✕ حذف</button>}
        {vbf.can('BTNSENDTOVISOR') && <button onClick={() => selected && setDetail(selected)} disabled={!selected}
          style={{ ...ui.btnItems, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>👁 ارجاع به ناظر</button>}
      </div>
      <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === 'Enter' && load(1, search)}
        style={{ ...ui.searchInput, flex: 1, minWidth: '180px' }} placeholder="جستجو (شماره قرارداد، دبیرخانه، سریال)..." />
      <button onClick={() => load(1, search)} style={ui.btnEdit}>🔍 جستجو</button>
      {loading && <span>⏳</span>}
      <CountBadge shown={data.length} total={pager.total} loading={loading} />
    </>
  );

  
  const cell = (r, c, sel) => {
    const tc = sel ? '#fff' : '#111';
    if (c.final) return <td style={{ ...ui.td, color: sel ? '#fff' : r.is_final ? '#b71c1c' : '#888', fontWeight: '700' }}>{r.is_final ? 'قطعی' : 'موقت'}</td>;
    if (c.yn)    return <td style={{ ...ui.td, color: sel ? '#fff' : r[c.k] ? '#1b5e20' : '#ccc', fontWeight: '700' }}>{r[c.k] ? 'بلی' : '•'}</td>;
    if (c.num)   return <td style={{ ...ui.tdNum, color: sel ? '#fff' : r[c.k] ? c.color : '#ccc' }}>{fmtNum(r[c.k])}</td>;
    if (c.mono)  return <td style={{ ...ui.td, fontFamily: 'monospace', fontSize: '11px', color: tc }}>{r[c.k] || '•'}</td>;
    if (c.fa)    return <td style={{ ...ui.td, color: tc }}>{r[c.k] ? toFa(r[c.k]) : '•'}</td>;
    return <td style={{ ...ui.td, textAlign: c.right ? 'right' : 'center', fontSize: '11px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r[c.k]}>{r[c.k] || '•'}</td>;
  };

  return (
    <>
      <ListPage user={user} onBack={onBack} title="رسیدگی نهایی" subtitle="بخش قراردادها — سامانه ارجان"
        toolbar={toolbar} error={!modal ? error : ''} pager={pager} loading={loading} onMore={p => load(p, search)}>
        <table style={{ ...ui.table, tableLayout: 'fixed' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
            <tr>
              {cols.map((c, i) => (
                <th key={i} style={{ ...ui.th, width: colW[i], minWidth: 40, position: 'relative', userSelect: 'none' }}>
                  {c.h}<span onMouseDown={e => startResize(i, e)} style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', cursor: 'col-resize' }} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => {
              const sel = selected?.id === r.id;
              const bg  = sel ? '#1a2f50' : r.havaleh_issued ? '#e8f5e9' : i % 2 === 0 ? '#fff' : '#fdf6e3';
              return (
                <tr key={r.id} style={{ background: bg, cursor: 'pointer' }}
                  onClick={() => setSelected(sel ? null : r)} onDoubleClick={() => { setSelected(r); setTimeout(openEdit, 0); }}
                  onMouseEnter={e => { if (!sel) e.currentTarget.style.background = '#e8f0fe'; }}
                  onMouseLeave={e => { if (!sel) e.currentTarget.style.background = bg; }}>
                  {cols.map((c, ci) => <React.Fragment key={ci}>{cell(r, c, sel)}</React.Fragment>)}
                </tr>
              );
            })}
          </tbody>
        </table>
        {!loading && data.length === 0 && <div style={ui.empty}>📭 رکوردی یافت نشد</div>}
      </ListPage>

      {(modal === 'new' || modal === 'edit') && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '900px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal === 'new' ? '＋ رسیدگی نهایی جدید' : `✎ ویرایش — سریال ${toFa(form.serial_no)}`}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>

            <div style={{ display: 'flex', gap: '4px', padding: '8px 16px 0', background: '#f8f9fa', flexWrap: 'wrap' }}>
              {[['contract', 'قرارداد و صورت‌وضعیت'], ['review', 'رسیدگی و ناظران'], ['letters', 'نامه‌ها و تاریخ‌ها']].map(([k, t]) => (
                <button key={k} onClick={() => setTab(k)}
                  style={{ padding: '7px 14px', border: 'none', borderRadius: '8px 8px 0 0', cursor: 'pointer', fontFamily: 'inherit', fontSize: '12px', fontWeight: '700',
                    background: tab === k ? '#fff' : 'transparent', color: tab === k ? '#4a148c' : '#888', borderBottom: tab === k ? '2px solid #4a148c' : '2px solid transparent' }}>{t}</button>
              ))}
            </div>

            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}

              {tab === 'contract' && (<>
                <div style={ui.row}>
                  <Lookup label="قرارداد" value={form.contract_disp} endpoint="/controls/lookup/contract/" onPick={pickContract} flex={2} />
                </div>
                <div style={ui.row}>
                  <TInput label="پیمانکار" val={form.contractor} onCh={() => {}} disabled />
                  <TInput label="نوع قرارداد" val={form.contract_type} onCh={() => {}} disabled />
                </div>
                <div style={ui.row}>
                  <TInput label="مبلغ قرارداد" val={fmtNum(form.contract_cost)} onCh={() => {}} disabled />
                  <TInput label="شروع قرارداد" val={form.contract_begin} onCh={() => {}} disabled flex={0.7} />
                </div>
                <div style={ui.divider} />
                <div style={ui.row}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <label style={ui.mlabel}>نوع صورت وضعیت</label>
                    <select value={form.request_type} onChange={e => changeType(Number(e.target.value))} style={ui.input}>
                      {REQUEST_TYPE.map((m, i) => <option key={i} value={i}>{m}</option>)}
                    </select>
                  </div>
                  <TInput label="شماره صورت وضعیت" val={form.request_no} onCh={v => F('request_no', v)} type="number" flex={0.7} />
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <label style={ui.mlabel}>محل پرداخت</label>
                    <select value={form.credit_place_type} onChange={e => F('credit_place_type', Number(e.target.value))} style={ui.input}>
                      {CREDIT_PLACE.map((m, i) => <option key={i} value={i}>{m}</option>)}
                    </select>
                  </div>
                </div>
                <div style={ui.row}>
                  <TInput label="مبلغ درخواستی پیمانکار (ریال)" val={form.request_amount_to_now} onCh={v => F('request_amount_to_now', v)} type="number" />
                  <DateField label="از تاریخ" val={form.from_date} onCh={v => F('from_date', v)} />
                  <DateField label="تا تاریخ" val={form.to_date} onCh={v => F('to_date', v)} />
                </div>
                <div style={ui.row}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
                    <input type="checkbox" checked={form.is_final} onChange={e => F('is_final', e.target.checked)} style={{ width: '18px', height: '18px' }} />
                    صورت وضعیت قطعی
                  </label>
                </div>
              </>)}

              {tab === 'review' && (<>
                <div style={ui.row}>
                  <Lookup label="سرناظر" value={form.supervisor} endpoint="/controls/lookup/people/"
                    onPick={r => setForm(f => ({ ...f, supervisor_id: r.id, supervisor: r.display }))} />
                  <Lookup label="رسیدگی کننده" value={form.handler} endpoint="/controls/lookup/people/"
                    onPick={r => setForm(f => ({ ...f, handler_id: r.id, handler: r.display }))} />
                </div>
                <div style={ui.row}>
                  <Lookup label="ناظر ابنیه" value={form.buildings_visor} endpoint="/controls/lookup/people/"
                    onPick={r => setForm(f => ({ ...f, buildings_visor_id: r.id, buildings_visor: r.display }))} />
                  <Lookup label="ناظر تاسیسات" value={form.installations_visor} endpoint="/controls/lookup/people/"
                    onPick={r => setForm(f => ({ ...f, installations_visor_id: r.id, installations_visor: r.display }))} />
                </div>
                <div style={ui.divider} />
                <div style={ui.row}>
                  <TInput label="مبلغ تایید شده (ریال)" val={form.confirmed_amount} onCh={v => F('confirmed_amount', v)} type="number" />
                  <TInput label="مبلغ دستگاه نظارت (ریال)" val={form.supervision_amount} onCh={v => F('supervision_amount', v)} type="number" />
                </div>
                <div style={ui.row}>
                  <TInput label="شماره دبیرخانه نظارت" val={form.supervision_no} onCh={v => F('supervision_no', v)} />
                  <DateField label="تاریخ دبیرخانه نظارت" val={form.supervision_date} onCh={v => F('supervision_date', v)} />
                </div>
              </>)}

              {tab === 'letters' && (<>
                <div style={ui.row}>
                  <TInput label="شماره سریال (خودکار)" val={form.serial_no} onCh={v => F('serial_no', v)} type="number" flex={0.7} />
                  <TInput label="شماره درخواست پیمانکار" val={form.contractor_letter_no} onCh={v => F('contractor_letter_no', v)} />
                  <DateField label="تاریخ درخواست پیمانکار" val={form.contractor_letter_date} onCh={v => F('contractor_letter_date', v)} />
                </div>
                <div style={ui.row}>
                  <TInput label="شماره دبیرخانه" val={form.secretariat_no} onCh={v => F('secretariat_no', v)} />
                  <DateField label="تاریخ دبیرخانه" val={form.secretariat_date} onCh={v => F('secretariat_date', v)} />
                  <DateField label="تاریخ ورود به رسیدگی" val={form.received_date} onCh={v => F('received_date', v)} />
                </div>
                <div style={ui.row}>
                  <DateField label="تاریخ ارجاع به رسیدگی" val={form.send_to_visor_date} onCh={v => F('send_to_visor_date', v)} />
                  <DateField label="تاریخ دریافت از رسیدگی" val={form.receive_from_visor_date} onCh={v => F('receive_from_visor_date', v)} />
                </div>
                <div style={ui.divider} />
                <div style={ui.row}>
                  <TInput label="شماره نامه خروج (خودکار)" val={form.send_letter_no} onCh={v => F('send_letter_no', v)} />
                  <DateField label="تاریخ نامه خروج" val={form.send_letter_date} onCh={v => F('send_letter_date', v)} />
                  <DateField label="تاریخ ماده ۴۰" val={form.date40} onCh={v => F('date40', v)} />
                </div>
                <div style={ui.row}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
                    <input type="checkbox" checked={form.send_to_contractor_request} onChange={e => F('send_to_contractor_request', e.target.checked)} style={{ width: '18px', height: '18px' }} />
                    ارسال به صدور حواله
                  </label>
                </div>
                <div style={ui.row}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <label style={ui.mlabel}>توضیح</label>
                    <input value={form.remark} onChange={e => F('remark', e.target.value)} style={ui.input} />
                  </div>
                </div>
              </>)}
            </div>

            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal === 'delete' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '440px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={ui.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign: 'center', padding: '26px' }}>
              <div style={{ fontSize: '34px', marginBottom: '10px' }}>🗑️</div>
              سریال {toFa(selected?.serial_no)} — {selected?.contractor}
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setModal(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNDELETE') && <button onClick={doDelete} disabled={saving} style={{ ...ui.btnSave, background: '#b71c1c' }}>{saving ? '⏳...' : 'بله، حذف'}</button>}
            </div>
          </div>
        </div>
      )}

      {detail && (
        <ControlRequestDetail ccrId={detail.id} contractTitle={`سریال ${toFa(detail.serial_no)} — ${detail.contractor}`} onClose={() => setDetail(null)} />
      )}

      {toast && <div style={ui.toast}>{toast}</div>}
    </>
  );
}
